const PREFIX = 'user';
export const PROMPT_LOGIN = PREFIX + ':prompt:login';
export const SET_SERVER = PREFIX + ':set:server';
export const SET_JWT = PREFIX + ':set:jwt';


export const  promptUserLogin = (value = true) => {
    return{
        type: PROMPT_LOGIN,
        result: value 
    }
}

export const setServer = (value) => {
    return{
        type: SET_SERVER,
        result: value 
    }
}

export const setJwtToken = (value) => {
    return{
        type: SET_JWT,
        result: value 
    }
}
